import React from 'react';
import { useTranslation } from 'react-i18next';
import Page from '../../../components/page/page';
import PageHeader from '../../../components/page/pageHeader';
import { QlikUIContext, Report, QlikWrapper } from 'globaleris-qlik-component';
import 'globaleris-qlik-component/dist/index.css';
import { getAppConfigurationValue } from '../../../redux';
import { AppConfigurationKey } from '../../../model/enums/appConfigurationKey';
import { useQlikContext } from '../../../hooks/useQlikContext';

export interface DemandForecastCPProps {}

export const DemandForecastCPPage: React.FC<DemandForecastCPProps> = () => {
  const [t] = useTranslation(['globalerisLibrary', 'demandForecast']);
  const { isContextInitialized, context } = useQlikContext();
  const fileName = getAppConfigurationValue(AppConfigurationKey.EmbeddedReport);

  return (
    <Page>
      <PageHeader title={`${t('demandForecast:title')}`}></PageHeader>
      {isContextInitialized &&
        <QlikUIContext.Provider value={context}>
          {<QlikWrapper component={<Report fileName={fileName} reportType={1} />} />}
        </QlikUIContext.Provider>
      }
    </Page>
  );
};
